import styled from "styled-components";

export const SelectFieldStyled = styled.div`
  .field-label {
    color: var(--slate-blue-color);
    font-weight: 500;
    font-size: 14px;
    margin-bottom: 6px;
  }
  .MuiInputBase-root {
    border-radius: 16px !important;
    height: 40px;
    padding: 14px 8px;
    width: 100%;
  }
  .MuiInputBase-input {
    font-size: 14px;
  }
  .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: 1px solid var(--royal-blue-color) !important;
    outline: none;
  }
`;
